import React from "react";
import {
  prizeLineColumnWidths,
  prizeLinesTableForField,
} from "../../../utility/checkPrizeLines";

const cellStyle = (align, extra = {}) => ({
  padding: "1px 5px",
  textAlign: align === "right" ? "right" : "left",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  verticalAlign: "bottom",
  fontVariantNumeric: align === "right" ? "tabular-nums" : "normal",
  ...extra,
});

const PrizeLinesTable = ({ field, values, fontSize }) => {
  const table = prizeLinesTableForField(field, values);
  const columns = prizeLineColumnWidths(field?.prizeLineColumns, 100);
  const lastIndex = Math.max(0, table.columns.length - 1);

  return (
    <table
      className="w-full border-collapse pointer-events-none"
      style={{
        tableLayout: "fixed",
        fontSize,
        lineHeight: 1.25,
        borderSpacing: 0,
      }}
      aria-label="Prize lines"
    >
      <colgroup>
        {columns.map((column) => (
          <col key={column.key} style={{ width: `${column.width}%` }} />
        ))}
      </colgroup>
      <thead>
        <tr>
          {table.columns.map((column) => (
            <th
              key={column.key}
              scope="col"
              style={cellStyle(column.align, {
                fontWeight: 700,
              })}
            >
              {column.label}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {table.rows.map((cells, rowIndex) => (
          <tr key={rowIndex}>
            {cells.map((cell, cellIndex) => (
              <td
                key={`${rowIndex}-${cellIndex}`}
                style={cellStyle(table.columns[cellIndex]?.align, {
                  paddingTop: 2,
                  paddingBottom: 2,
                })}
              >
                {cell}
              </td>
            ))}
          </tr>
        ))}
        {table.moreLabel ? (
          <tr>
            <td
              colSpan={table.columns.length}
              style={cellStyle("left", {
                fontStyle: "italic",
                color: "rgba(15,23,42,0.65)",
                paddingTop: 2,
              })}
            >
              {table.moreLabel}
            </td>
          </tr>
        ) : null}
        <tr>
          {lastIndex > 0 ? (
            <td
              colSpan={lastIndex}
              style={cellStyle("left", {
                fontWeight: 700,
              })}
            >
              {table.totalLabel}
            </td>
          ) : null}
          <td
            style={cellStyle("right", {
              fontWeight: 700,
              ...(lastIndex === 0
                ? { display: "flex", justifyContent: "space-between" }
                : {}),
            })}
          >
            {lastIndex === 0 ? (
              <>
                <span>{table.totalLabel}</span>
                <span>{table.totalAmount}</span>
              </>
            ) : (
              table.totalAmount
            )}
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default PrizeLinesTable;
